import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { JSONApiDataObject, ReduxEntity, SellerPortfolio } from 'Douleutaras/types';
import { RootState } from 'Douleutaras/redux/store';

const sellerProfilesPortfolioAdapter = createEntityAdapter<JSONApiDataObject<SellerPortfolio>>({
  selectId: item => item.id
});

export const sellerProfilesPortfolioSlice = createSlice({
  name: 'sellerProfilesPortfolio',
  initialState: sellerProfilesPortfolioAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<JSONApiDataObject<SellerPortfolio>>),
  reducers: {
    sellerProfilesPortfolioAdded: (state, action) => {
      sellerProfilesPortfolioAdapter.setMany(state, action.payload);
    }
  }
});

export const sellerProfilesPortfolioSelectors = sellerProfilesPortfolioAdapter.getSelectors(
  (state: RootState) => state.sellerProfilesPortfolio);
export default sellerProfilesPortfolioSlice.reducer;
